import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { BroadcastMessageService } from './broadcast-message.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HeaderService } from 'src/app/shared/services/header.service';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from 'src/app/shared/services/session.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-broadcast-message',
  templateUrl: './broadcast-message.component.html',
  styleUrls: ['./broadcast-message.component.scss']
})
export class BroadcastMessageComponent implements OnInit {
  selectedOptions: any;
itemsControl = new FormControl([]);
searchSelectedValues: any[] = []; 
selectedValues: any[] = [];
formattedSelectedValues: string = ''; 
primaryList:any;
searchText: any;
itemsperpage:number;
currentPage: number;
page: number;
pageLimit:number;
searchControl = new FormControl();
title:string;
message: string;
hostList:any;
defaultSelectedValues: any[] = []; 
searchForm: FormGroup;
resultCount:number;
modalRef: BsModalRef;

@ViewChild('template') template: TemplateRef<any>;

  constructor(
    private service: BroadcastMessageService,
    private modalService: BsModalService,
    private _header: HeaderService,
    private toastrService: ToastrService,
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private fb: FormBuilder

  ) { }

  ngOnInit(): void {
    this._header.manageBroadcastHeading.next(true);
    this.route.queryParams.subscribe(params => {
      let paramPage = params['page'];
      this.page = parseInt(params['page']);

      if (typeof paramPage == 'undefined') {
        this.page = 1;
      } else {
        this.page = parseInt(paramPage);
      }
    });
    if (this.page) {
      this.currentPage = this.page;
    }
    this.searchForm = this.fb.group({
      search: ['', Validators.required], 
      selectedNames: [[]] 
    });

    this.getBroadCastList();
   
  }

  ngOnDestroy() {
    this._header.manageBroadcastHeading.next(false);
  }




onChange(event: MatSelectChange): void {
  const newValues = event.value; 
  const oldValues = this.searchSelectedValues; 
  
  const addedValues = newValues.filter(item => !oldValues.includes(item));
  
  const removedValues = oldValues.filter(item => !newValues.includes(item));
  
  
  if (addedValues.length) {
    this.searchSelectedValues = [...this.searchSelectedValues, ...newValues]; 
    console.log('adding')
    
  } else  {
    this.searchSelectedValues =this.searchSelectedValues.filter(item => !removedValues.includes(item));
    console.log('deleting')
  }
  
  this.selectedValues = this.removeDuplicatesById(this.searchSelectedValues);
  console.log('selected Values 123', this.selectedValues)
  this.formatSelectedValues(this.selectedValues);
}

openModal() {
  this.modalRef = this.modalService.show(this.template);
}

getDisplayedValue(item: any): string {
  let parts = [];

  if (item.email) {
    parts.push(item.email);
  }

  if (item.firstName) {
    parts.push(item.firstName);
  }

  if (item.mobileNo) {
    parts.push(item.mobileNo);
  }

  return parts.join(', ');
}

sendMessage() {
  const userIds = this.selectedOptions.map(item => item?._id);
  const data = {
    userIds : userIds,
    title : this.title,
    body : this.message
  };

  this.service.getMessageList(data).subscribe((res: any) => {
    if (res.statusCode == 200) {
      this.hostList = res.message;
      this.toastrService.success("Message has been sent Successfully");
      this.defaultSelectedValues = []; 
      this.searchSelectedValues = []; 
      this.itemsControl.setValue([]);
      this.formattedSelectedValues = ''
    this.title = '';
    this.message = '';
    this.searchForm.get('selectedNames').setValue([]);
    this.searchForm.get('search').setValue('');
      this.resultCount = res.totalCount;
      this.modalRef.hide();
    }
  });
}

onOptionClick(event: MouseEvent, item: any): void {
  //   console.log('MouseEvent',event)
  //   // Prevent the default behavior (selection) when clicking on an already selected option
  //   event.preventDefault();
  //   event.stopPropagation();
  
  //   // Deselect the option
  //     this.searchSelectedValues = this.selectedValues.filter(value => value !== item);
   }

checkEmpty(event: any) {
  if (event.target.value == "") {
    this.getBroadCastList();
    document.getElementById('search').blur();  }
}


getBroadCastList() {
  this.service.getBroadCast({}).subscribe((res: any) => {
    if (res.statusCode === 200) {
      const newPrimaryList = res.output;
      this.primaryList = newPrimaryList
      this.selectedOptions = this.findMatchingElements(this.primaryList, this.selectedValues)

    } else {
      this.primaryList = [];
    }
  });
}
onSearch(onSearch: any) {
  this.searchText = onSearch;
  this.getServiceBySearch(this.searchText, this.page, this.pageLimit);

}

getServiceBySearch(searchKey: any, page: any, pageLimit: any) {
  this.service.getmessageBySearch({
    "keyword": searchKey,
    "page": page,
    "limit": pageLimit
  }).subscribe((res: any) => {
    if (res.statusCode == 200) {
      this.primaryList= res.output.result;
      this.selectedOptions = this.findMatchingElements(this.primaryList, this.selectedValues)
            } else {
      this.primaryList = [];
    }
  });
}

findMatchingElements(outputArray, selectedArray) {
  return outputArray.filter(element => selectedArray.some(selected => selected._id === element._id));
}

removeDuplicatesById(items: any[]): any[] {
  const uniqueById = items.reduce((acc: any[], currentItem: any) => {
    if (!acc.some(item => item._id === currentItem._id)) {
      acc.push(currentItem);
    }
    return acc;
  }, []);
  return uniqueById;
}

formatSelectedValues(selectedValues): void {
  this.formattedSelectedValues = selectedValues.map(value => value.email).join(', ');
}

}
